import { Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public loading$$ = new BehaviorSubject<boolean>(false);

  constructor() { }

  public get loading$(): Observable<boolean> {
    return this.loading$$.asObservable();
  }

  public showLoader(): void {
    this.loading$$.next(true);
  }

  public hideLoader(): void {
    this.loading$$.next(false);
  }
  
}
